
'use server';

import type { GenerateQuotationOutput } from '@/backend-types';

const API_BASE_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL;

export type { GenerateQuotationOutput };
export interface GenerateQuotationInput {
  projectDescription: string;
}

export async function getQuotation(input: GenerateQuotationInput): Promise<{
  success: boolean;
  data?: GenerateQuotationOutput;
  message?: string;
}> {
  console.log(`[Action] Calling backend to generate quotation at: ${API_BASE_URL}/api/generate/quotation`);
  try {
    const token = 'YOUR_JWT_TOKEN_HERE'; // In a real app, you'd get this from the user's session
    const response = await fetch(`${API_BASE_URL}/api/generate/quotation`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${token}` // This will be needed when auth is fully implemented
        },
        body: JSON.stringify(input),
    });

    const result = await response.json();

    if (!response.ok) {
        throw new Error(result.message || 'Failed to generate quotation.');
    }
    
    console.log('[Action] Successfully received quotation from backend.');
    return { success: true, data: result.data };
  } catch (error) {
    console.error('Error generating quotation:', error);
    const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred.';
    return { success: false, message: `Failed to generate quotation: ${errorMessage}` };
  }
}
